var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFallingEdge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 44,
    viewBox: "0 0 227 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qdhi91vmma)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E7AFF",
    d: "M44 37V6h2v31z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.984 5a1 1 0 0 0-1 1v30.526a.474.474 0 1 0 .948 0V6H46a1 1 0 0 0-1-1H10.984z",
    fill: "#07070F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 6a1 1 0 0 1 1-1h33a1 1 0 0 1 1 1H77zM143 6a1 1 0 0 1 1-1h33a1 1 0 0 1 1 1h-35zM208.984 6a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1h-28zM43.984 37h34a1 1 0 0 1-1 1h-32a1 1 0 0 1-1-1zM109.984 37h34a1 1 0 0 1-1 1h-32a1 1 0 0 1-1-1zM175.984 37h34a1 1 0 0 1-1 1h-32a1 1 0 0 1-1-1zM76.984 37V6h1v31z",
    fill: "#07070F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E7AFF",
    d: "M110 37V6h2v31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07070F",
    fillOpacity: 0.4,
    d: "M142.984 37V6h1v31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E7AFF",
    d: "M176 37V6h2v31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07070F",
    fillOpacity: 0.4,
    d: "M208.984 37V6h1v31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.94 28.06a1.5 1.5 0 0 0 2.12 0l9.547-9.545a1.5 1.5 0 1 0-2.122-2.122L45 24.88l-8.485-8.486a1.5 1.5 0 1 0-2.122 2.122l9.546 9.546zM43.5 24v3h3v-3h-3zM109.939 28.06a1.501 1.501 0 0 0 2.122 0l9.546-9.545a1.501 1.501 0 0 0-2.122-2.122L111 24.88l-8.485-8.486a1.5 1.5 0 0 0-2.122 2.122l9.546 9.546zM109.5 24v3h3v-3h-3zM175.939 28.06a1.501 1.501 0 0 0 2.122 0l9.546-9.545a1.501 1.501 0 0 0-2.122-2.122L177 24.88l-8.485-8.486a1.5 1.5 0 0 0-2.122 2.122l9.546 9.546zM175.5 24v3h3v-3h-3z",
    fill: "#1E7AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "qdhi91vmma"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h227v44H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallingEdge);
export default __webpack_public_path__ + "static/media/falling-edge.ba297265.svg";
export { ForwardRef as ReactComponent };